import { FC } from "react";
import { useTranslation } from "react-i18next";

import Desktop from "../../../../assets/images/content/introduction/the-home-appliance-industry-in-europe/the-home-appliance-industry-in-europe-desktop.png";
import Mobile from "../../../../assets/images/content/introduction/the-home-appliance-industry-in-europe/the-home-appliance-industry-in-europe-mobile.png";

const HomeApplianceIndustryInEurope: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col">
			<img
				className="hidden md:block w-full self-center"
				src={Desktop}
				alt={t("pages.introduction.homeApplianceIndustryInEurope.blocks.visual.alt") as string}
				title={t("pages.introduction.homeApplianceIndustryInEurope.blocks.visual.alt") as string}
			/>
			<img
				className="block md:hidden w-full max-w-sm self-center"
				src={Mobile}
				alt={t("pages.introduction.homeApplianceIndustryInEurope.blocks.visual.alt") as string}
				title={t("pages.introduction.homeApplianceIndustryInEurope.blocks.visual.alt") as string}
			/>
		</div>
	);
};

export { HomeApplianceIndustryInEurope };
